import {Component, computed, inject, input} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {TranslocoPipe} from '@jsverse/transloco';
import {DirectusService, DirectusTranslatedItem} from '@frontend/directus';
import {CertificationLabelComponent} from '../certification-label/certification-label.component';

@Component({
  selector: 'app-certification-list',
  imports: [TranslocoPipe, CertificationLabelComponent],
  templateUrl: './certification-list.component.html',
})
export class CertificationListComponent {
  private readonly directusService = inject(DirectusService);

  readonly certificationDirectusUuids = input.required<string[]>();

  private readonly certificationOptions = toSignal(
    this.directusService.loadDirectusDropdown('hr_tool_certification'),
    {initialValue: []},
  );

  readonly certifications = computed((): DirectusTranslatedItem[] => {
    const options = this.certificationOptions();
    return this.certificationDirectusUuids()
      .map((uuid) => options.find((option) => option.id === uuid))
      .filter((option): option is DirectusTranslatedItem => !!option);
  });
}
